import userExcursionApi from "@/services/api/UserExcursion";
import { UserExcursion } from "@/services/api/UserExcursion/type";
import { useEffect, useState } from "react";

const useFetchUserExcursionFromStoreId = (storeId: string) => {
  const [userExcursions, setUserExcursions] = useState<UserExcursion[] | null>(
    null
  );

  const fetchUserExcursionsFromStoreId = async () => {
    try {
      const userExcursionsResponse =
        await userExcursionApi.getUserExcursionsFromStoreId(storeId);

      setUserExcursions(userExcursionsResponse);
    } catch (error) {
      console.error("Error fetching euser excursions from a storeId: ", error);
    }
  };

  useEffect(() => {
    fetchUserExcursionsFromStoreId();
  }, [storeId]);

  return { userExcursions };
};

export default useFetchUserExcursionFromStoreId;
